import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useLocation } from 'react-router-dom';
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  RSelect,
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { DELETE, GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, UncontrolledDropdown } from "reactstrap";
import { INVENTORY_TYPE, MATERIAL_CATEGORY_GROUP, MATERIAL_INVENTORY_REQUEST_STATUS, renderPageStyle } from "../../utils/Utils";

const MATERIAL_CATEGORY_GROUP_OPTIONS = Object.keys(MATERIAL_CATEGORY_GROUP).map((c) => ({
  label: MATERIAL_CATEGORY_GROUP[c],
  value: c,
}));

const INVENTORY_TYPE_OPTIONS = Object.keys(INVENTORY_TYPE).map((c) => ({
  label: INVENTORY_TYPE[c],
  value: c,
}));


const MATERIAL_INVENTORY_REQUEST_STATUS_OPTIONS = Object.keys(MATERIAL_INVENTORY_REQUEST_STATUS).map((c) => ({
  label: MATERIAL_INVENTORY_REQUEST_STATUS[c],
  value: c,
}));


const MaterialInventoryRequest = () => {
  const printRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [data, setData] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);

  const [loading, setLoading] = useState(false);
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [deleteId, setDeleteId] = useState();

  const [view, setView] = useState({
    isDelete: false,
  });

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ isDelete: false, isDuplicate: false });
    setDeleteId();
  };


  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  const deleteRequest = (id) => {
    if (!id) {
      return;
    }
    DELETE(`material-inventory/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const [rangeDate, setRangeDate] = useState({
    startDate: searchParams.get('startDate') ? moment(searchParams.get('startDate')).startOf('days').toDate() : moment().startOf("months").toDate(),
    endDate: searchParams.get('endDate') ? moment(searchParams.get('endDate')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const [filter, setFilter] = useState({
    categoryGroup: searchParams.get('categoryGroup') || undefined,
    type: searchParams.get('type') || undefined,
    warehouseId: searchParams.get('warehouseId') || undefined,
    buyer: searchParams.get('buyer') || undefined,
    requestedBy: searchParams.get('requestedBy') || undefined,
    approvedBy: searchParams.get('approvedBy') || undefined,
    confirmedBy: searchParams.get('confirmedBy') || undefined,
    status: searchParams.get('status') || undefined,
  });

  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate)?.startOf('days').toDate() : startDate,
      endDate: endDate ? moment(endDate)?.endOf('days').toDate() : endDate
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  };

  const colTable = [
    {
      Header: "Loại",
      accessor: (item) => INVENTORY_TYPE[item.type],
    },
    {
      Header: "Mã",
      accessor: (item) => item.id,
    },
    {
      Header: "Nhóm danh mục",
      accessor: (item) => MATERIAL_CATEGORY_GROUP[item.categoryGroup],
    },
    {
      Header: "Ngày",
      accessor: (item) => moment(item.date).format('DD-MM-YYYY'),
    },
    {
      Header: "Kho",
      accessor: (item) => item?.warehouse?.name,
    },
    {
      Header: "Nội dung yêu cầu",
      accessor: (item) => item.description,
    },
    {
      Header: "người mua",
      accessor: (item) => item.buyerUser?.name,
    },
    {
      Header: "% Tấn Lộc",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.percentTL || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "% Cường Thịnh",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.percentCT || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Tổng chi phí",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.total || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Trạng thái",
      className: 'text-right',
      accessor: (item) => MATERIAL_INVENTORY_REQUEST_STATUS[item.status],
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <a
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        history.push(`/material-inventory-request/create?duplicateId=${item.id}`);
                      }}
                    >
                      <Icon
                        name={"copy"}
                      ></Icon>
                      <span>Nhân bản</span>
                    </a>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        history.push(`/material-inventory-request/${item.id}`)
                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Sửa</span>
                    </DropdownItem>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  useEffect(() => {
    GET("/user", {}, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });

    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, [])
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.categoryGroup ? { categoryGroup: filter.categoryGroup } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      ...(filter.buyer ? { buyer: filter.buyer } : {}),
      ...(filter.requestedBy ? { requestedBy: filter.requestedBy } : {}),
      ...(filter.approvedBy ? { approvedBy: filter.approvedBy } : {}),
      ...(filter.confirmedBy ? { confirmedBy: filter.confirmedBy } : {}),
      ...(filter.status ? { status: filter.status } : {}),

    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    let params = {
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      ...(filter.categoryGroup ? { categoryGroup: filter.categoryGroup } : {}),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      ...(filter.buyer ? { buyer: filter.buyer } : {}),
      ...(filter.requestedBy ? { requestedBy: filter.requestedBy } : {}),
      ...(filter.approvedBy ? { approvedBy: filter.approvedBy } : {}),
      ...(filter.confirmedBy ? { confirmedBy: filter.confirmedBy } : {}),
      ...(filter.status ? { status: filter.status } : {}),
    };

    GET(`/material-inventory`, params, true)
      .then(({ data }) => {
        setData(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, filter]);

  return (
    <React.Fragment>
      <Head title="Đề xuất"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đề xuất</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>

                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Lọc người mua"
                          classNamePrefix="form-control"
                          options={userOptions}
                          value={userOptions.find(
                            (c) => c.value === +filter.buyer
                          ) || null}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              buyer: val?.value || undefined,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Lọc người đề xuất"
                          classNamePrefix="form-control"
                          options={userOptions}
                          value={userOptions.find(
                            (c) => c.value === +filter.requestedBy
                          ) || null}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              requestedBy: val?.value || undefined,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Lọc người duyệt"
                          classNamePrefix="form-control"
                          options={userOptions}
                          value={userOptions.find(
                            (c) => c.value === +filter.approvedBy
                          ) || null}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              approvedBy: val?.value || undefined,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Lọc người chốt"
                          classNamePrefix="form-control"
                          options={userOptions}
                          value={userOptions.find(
                            (c) => c.value === +filter.confirmedBy
                          ) || null}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              confirmedBy: val?.value || undefined,
                            })
                          }
                        />
                      </div>
                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">

                    <li>
                      <div className="form-group">
                        <div className="form-control-wrap">
                          <RSelect
                            isClearable
                            placeholder={"Lọc theo kho"}
                            options={warehouseOptions}
                            value={warehouseOptions.find((c) => c.value === filter.warehouseId) || null}
                            onChange={(val) => {
                              setFilter({
                                ...filter,
                                warehouseId: val?.value || undefined,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Tìm kiếm danh mục"
                          classNamePrefix="form-control"
                          options={MATERIAL_CATEGORY_GROUP_OPTIONS}
                          value={MATERIAL_CATEGORY_GROUP_OPTIONS.find(
                            (c) => c.value === filter.categoryGroup
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              categoryGroup: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Tìm kiếm loại"
                          classNamePrefix="form-control"
                          options={INVENTORY_TYPE_OPTIONS}
                          value={INVENTORY_TYPE_OPTIONS.find(
                            (c) => c.value === filter?.type
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              type: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Tìm kiếm trạng thái"
                          classNamePrefix="form-control"
                          options={MATERIAL_INVENTORY_REQUEST_STATUS_OPTIONS}
                          value={MATERIAL_INVENTORY_REQUEST_STATUS_OPTIONS.find(
                            (c) => c.value === filter?.status
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              status: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            history.push('/material-inventory-request/create')
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm yêu cầu</span>
                        </Button>
                      </div>
                    </li>
                    <li>
                      <Button
                        color="primary"
                        onClick={() => {
                          history.goBack();
                        }}
                      >
                        <span>Trở về</span>
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3" ref={printRef}>
                  <style>{renderPageStyle()}</style>
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
      <Modal isOpen={view.isDelete} toggle={() => onFormCancel()} >
        <ModalBody className="modal-body-lg text-center">
          <div className="nk-modal">
            <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
            <h4 className="nk-modal-title">
              Bạn có chắc muốn xoá giao dịch này không ?{" "}
            </h4>
            <div className="nk-modal-action mt-5 d-flex justify-content-around">
              <Button
                color="light"
                size="lg"
                className="btn-mw mr-5"
                onClick={() => onFormCancel()}
              >
                Huỷ bỏ
              </Button>
              <Button
                color="primary"
                size="lg"
                className="btn-mw"
                onClick={(ev) => {
                  ev.preventDefault();
                  deleteRequest(deleteId);
                }}
              >
                Xác nhận
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>

    </React.Fragment>
  );
};

export default MaterialInventoryRequest;
